import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BRAND } from "../lib/constants";

const NAV = [
  { id: "services", label: "Services" },
  { id: "work", label: "Our Work" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const Header = ({ onBook }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <img src={BRAND.logoUrl} alt="Revive Pro Detailing" className="h-12 w-12 object-contain" />
          <div className="hidden sm:flex flex-col items-start leading-none">
            <span className="font-display text-xl font-bold tracking-tight text-white group-hover:text-[#DC2626] transition-colors">
              REVIVE
            </span>
            <span className="font-mono-accent text-[10px] text-zinc-500">PRO DETAILING</span>
          </div>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollTo(n.id)}
              className="font-mono-accent text-xs text-zinc-300 hover:text-[#DC2626] transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${BRAND.phoneRaw}`}
            data-testid="header-phone-link"
            className="hidden lg:flex items-center gap-2 text-zinc-300 hover:text-white transition-colors"
          >
            <Phone className="h-4 w-4" />
            <span className="font-mono-accent text-xs">{BRAND.phone}</span>
          </a>
          <button
            data-testid="header-book-btn"
            onClick={onBook}
            className="hidden sm:inline-flex items-center bg-[#DC2626] hover:bg-[#EF4444] text-white font-display font-bold uppercase tracking-wider text-sm px-6 py-3 transition-colors"
          >
            Book Now
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A0A0A] border-t border-white/5" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => scrollTo(n.id)}
                className="font-display uppercase tracking-wider text-left text-zinc-200 hover:text-[#DC2626]"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="mobile-book-btn"
              onClick={() => {
                setOpen(false);
                onBook();
              }}
              className="bg-[#DC2626] text-white font-display font-bold uppercase tracking-wider text-sm px-6 py-3"
            >
              Book Now
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
